import React, { useEffect } from "react"
import PropTypes from "prop-types"
import "./layout.css"
import NavBar from "./organisms/NavBar"
import CoookieBanner from "./organisms/CoookieBanner"
import Footer from './organisms/Footer'

const NF_HOTEL_ID = 1480
const NF_CALENDAR_SRC = "https://nfhotel.pl/nf-be/booking-calendar.js"
const NF_FLOATING_SRC = "https://nfhotel.pl/nf-be/floating-booking.js"
const NF_LOADER_SRC = "https://booking.nfhotel.pl/new/loader.js"

const loadScript = (src) => {
  const existing = document.querySelector(`script[src="${src}"]`)
  if (existing) {
    if (existing.dataset.nfLoaded === "true") {
      return Promise.resolve()
    }
    return new Promise((resolve, reject) => {
      existing.addEventListener("load", resolve, { once: true })
      existing.addEventListener("error", reject, { once: true })
    })
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement("script")
    script.src = src
    script.onload = () => {
      script.dataset.nfLoaded = "true"
      resolve()
    }
    script.onerror = reject
    document.body.appendChild(script)
  })
}

const loadNfHotelBooking = () => {
  if (window.__nfHotelBookingLoader) {
    return window.__nfHotelBookingLoader
  }

  window.__nfHotelBookingLoader = (async () => {
    await loadScript(NF_CALENDAR_SRC)
    await loadScript(NF_FLOATING_SRC)
    if (typeof window.nfHotelBooking?.setup === "function") {
      window.nfHotelBooking.setup(NF_HOTEL_ID)
    }
    await loadScript(NF_LOADER_SRC)
  })().catch((error) => {
    window.__nfHotelBookingLoader = null
    console.error("nfHotel booking failed to load", error)
  })

  return window.__nfHotelBookingLoader
}

const Layout = ({ children, path, }) => {
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") {
      return
    }
    loadNfHotelBooking()
  }, [])

  return (
    <>
      <CoookieBanner />
      <NavBar path={path} />
      <main>{children}</main>
      <footer id="footer">
        <Footer />
      </footer>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  path: PropTypes.string.isRequired,
}

export default Layout
